import React, { useRef, useState } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const formRef = useRef();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');

    // Ici tu peux envoyer les données vers ton API ou backend
    // Exemple avec fetch :
    fetch('/api/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
      .then((res) => {
        if (res.ok) {
          setStatus('success');
          setFormData({ name: '', email: '', subject: '', message: '' });
        } else {
          throw new Error('Erreur serveur');
        }
      })
      .catch(() => setStatus('error'))
      .finally(() => {
        setTimeout(() => setStatus(null), 5000);
      });
  };

  return (
    <section id="contact" className="contact">
      <div className="container-contact">
        <h2 className="section-title">Contactez-nous</h2>
        <p className="section-subtitle">Prêt à démarrer votre projet?</p>

        <div className="contact-content">
          <form ref={formRef} onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <input type="text" name="name" placeholder="Votre nom" required value={formData.name} onChange={handleChange} />
            </div>
            <div className="form-group">
              <input type="email" name="email" placeholder="Votre email" required value={formData.email} onChange={handleChange} />
            </div>
            <div className="form-group">
              <input type="text" name="subject" placeholder="Sujet" value={formData.subject} onChange={handleChange} />
            </div>
            <div className="form-group">
              <textarea name="message" placeholder="Votre message" required value={formData.message} onChange={handleChange}></textarea>
            </div>
            <button type="submit" className="btn" disabled={status === 'sending'}>
              {status === 'sending' ? 'Envoi en cours...' : 'Envoyer le message'}
            </button>

            {status === 'success' && <div className="alert success">Message envoyé avec succès!</div>}
            {status === 'error' && <div className="alert error">Une erreur est survenue.</div>}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
